/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

const useStyles = makeStyles()(theme => {
  return {
    root: {
      backgroundColor: theme.palette.background.paper,
      position: 'absolute',
      height: '100%'
    },
    titleAlignment: {
      fontSize: Tokens.spacing['$sp-6'],
      marginBottom: Tokens.spacing['$sp-4'],
      color: theme.palette.text.primary
    },
    subtext: {
      color: theme.palette.text.secondary
    },
    innerContent: {
      position: 'absolute',
      top: '30%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center'
    },
    alignment: {
      marginTop: Tokens.spacing['$sp-5'],
      marginBottom: Tokens.spacing['$sp-5'],
    },
    secondaryButton: {
      display: 'block',
      fontWeight: 'bold',
    }
  };
});

export default useStyles;
